<template>
    <div class="card py-5 px-5 has-background-secondary-lighted mb-6">
        <div
            class="is-flex is-align-items-center"
            v-on:click="toggleCollapse"
            data-testid="SiiDisconnectToggleDrop"
            role="button"
        >
            <div>
                <img class="mr-5" style="width:76px" :src="siiLogo" />
            </div>
            <div>
                <FintocLogo
                    class="is-relative mr-3"
                    style="width:72px;height:17px;top:4px"
                />
                <p class="has-text-weight-semibold is-size-5 mt-1">
                    {{ company.name }}
                </p>
                <p>rut. {{ company.rut }}</p>
            </div>
            <div class="ml-auto">
                <i class="material-icons is-size-3 is-relative" style="top:3px;cursor:pointer">
                    {{
                        collapseIsOpen
                            ? "keyboard_arrow_up"
                            : "keyboard_arrow_down"
                    }}
                </i>
            </div>
        </div>
        <b-collapse :open="collapseIsOpen" animation="slide">
            <template>
                <div>
                    <div class="horizontal-separator my-4"></div>
                    <ul>
                        <li class="mt-4">
                            <span class="is-inline-block" style="width:280px"
                                >Documentos:</span
                            >
                            <div>
                                <span
                                    v-for="item in obligationsList"
                                    v-bind:key="item.name"
                                    class="has-text-weight-semibold"
                                    >{{ item }}</span
                                >
                            </div>
                        </li>
                    </ul>
                    <div class="horizontal-separator my-4"></div>
                    <div class="is-flex is-justify-content-space-between">
                        <div>
                            <p class="has-text-weight-semibold mb-2">
                                ¿Deseas desconectar tu cuenta del Servicio de
                                Impuestos Internos?
                            </p>
                            <ul style="list-style:disc" class="pl-4">
                                <li>
                                    Al eliminar tu conexión la información
                                    deberá ser actualizado manualmente.
                                </li>
                                <li>
                                    Los documentos traidos desde el servicio de
                                    impuestos internos quedaran en la tabla,
                                    pero no podran ser editados o borrados.
                                </li>
                            </ul>
                        </div>
                        <div style="white-space:nowrap">
                            <b-button
                                size="is-small"
                                type="is-primary"
                                aria-label="desconectar"
                                data-testid="disconnectButton"
                                @click="triggerConfirmation"
                                v-if="!showConfirmation"
                            >
                                <span
                                    class="is-inline-flex is-align-items-center"
                                >
                                    <span>Desconectar</span>
                                    <i
                                        class="material-icons is-size-6 icon-clear ml-1"
                                    >
                                        power_off
                                    </i>
                                </span>
                            </b-button>
                            <div v-else>
                                <b-button
                                    size="is-small"
                                    type="is-primary"
                                    :disabled="loading"
                                    @click="confirm"
                                >
                                    <div
                                        class="is-inline-flex is-align-items-center"
                                    >
                                        <span>Si, desconectar</span>
                                        <i
                                            class="material-icons is-size-6 icon-clear ml-1"
                                        >
                                            power_off
                                        </i>
                                    </div>
                                </b-button>
                                <b-button
                                    class="ml-3"
                                    size="is-small"
                                    :disabled="loading"
                                    @click="cancelConfirmation"
                                >
                                    Mantener
                                </b-button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </b-collapse>
    </div>
</template>

<script>
import FintocLogo from "@/components/svg/FintocLogo.vue";
import siiLogo from "@/assets/images/sii.svg";
import { mapState } from "vuex";

export default {
    name: "SiiDisconnect",
    components: {
        FintocLogo,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            siiLogo: siiLogo,
            collapseIsOpen: false,
            showConfirmation: false,
        };
    },
    methods: {
        toggleCollapse() {
            this.collapseIsOpen = !this.collapseIsOpen;
        },
        triggerConfirmation() {
            this.showConfirmation = true;
        },
        cancelConfirmation() {
            this.showConfirmation = false;
        },
        confirm() {
            this.$emit("onDisconnectSii");
        },
    },
    computed: {
        ...mapState("taxDocument", ["obligationTypesList"]),
        ...mapState("userAuth", ["company"]),
        obligationsList() {
            const obligationTypesList = this.obligationTypesList.filter(
                (item) => {
                    if (item.sii_code !== null) {
                        return true;
                    }
                    return false;
                }
            );
            const formatedObligations = obligationTypesList.map(
                (item) => item.name + ", "
            );
            return formatedObligations;
        },
    },
};
</script>
